export const conference = {
	title: "Conferencia de evento",
	eventOpen: "Evento abierto",
	closeEventToConference: "Debe cerrar el evento para realizar la conferencia",
	titleTypeOfConference: {
		resumed: "Cuadro de resumen",
		integratedIncome: "Tarifas sobre APP y terminales integradas (crédito/débito)",
		notIntegratedIncome: "Tarifas sobre terminales POS no integradas (crédito/débito)",
		zigFees: "Tarifas Zig",
		securityDeposit: "Depósito de garantía",
		otherCharges: "Otros cargos",
		rechargeRefund: "Devolución de recarga",
	},
	columnsTable: {
		name: "Nombre",
		grossValue: "Valor Bruto",
		tax: "Tarifa",
		taxReceivedOrPayable: "Por cobrar / Por pagar Zig",
		receiptForecast: "Previsión de cobro",
	},
	conference: "Conferencia",
	processConference: "Procesar conferencia",
};
